module.exports = __webpack_public_path__ + "static/media/mr_imoveis.6ce2a93e.svg";